import React from "react";
import { ProjectPlanPageContent, ProjectPlanPageStateProvider } from ".";
import { ConfirmationWithCommentDialogStateProvider } from "../dialog/confirmation-with-comment-dialog/ConfirmationWithCommentDialogStateProvider";
import { InputProjectInformationDialogStateProvider } from "../dialog/input-project-information-dialog/InputProjectInformationDialogStateProvider";
import { InputCostEstimationDialogStateProvider } from "../dialog/input-cost-estimation-dialog/InputCostEstimationDialogStateProvider";
import { InputComponentRequirementDialogStateProvider } from "../dialog/input-component-requirement-dialog/InputComponentRequirementDialogStateProvider";
import { LinkComponentProjectDialogStateProvider } from "../dialog/link-component-project-dialog/LinkComponentProjectDialogStateProvider";
import { ProjectStakeholderListStateProvider } from "../dialog/project-stakeholder-list/ProjectStakeholderListStateProvider";
import { InputStakeholderDialogStateProvider } from "../dialog/input-stakeholder-dialog/InputStakeholderDialogStateProvider";
import { UserSearchDialogStateProvider } from "../dialog/user-search-dialog/UserSearchDialogStateProvider";
import { MemoEditDialogStateProvider } from "../dialog/memo-edit-dialog";

export const ProjectPlanPage = () => {
  return (
    <MemoEditDialogStateProvider>
      <ConfirmationWithCommentDialogStateProvider>
        <InputProjectInformationDialogStateProvider>
          <InputCostEstimationDialogStateProvider>
            <InputComponentRequirementDialogStateProvider>
              <LinkComponentProjectDialogStateProvider>
                <ProjectStakeholderListStateProvider>
                  <InputStakeholderDialogStateProvider>
                    <UserSearchDialogStateProvider>
                      <ProjectPlanPageStateProvider>
                        <ProjectPlanPageContent></ProjectPlanPageContent>
                      </ProjectPlanPageStateProvider>
                    </UserSearchDialogStateProvider>
                  </InputStakeholderDialogStateProvider>
                </ProjectStakeholderListStateProvider>
              </LinkComponentProjectDialogStateProvider>
            </InputComponentRequirementDialogStateProvider>
          </InputCostEstimationDialogStateProvider>
        </InputProjectInformationDialogStateProvider>
      </ConfirmationWithCommentDialogStateProvider>
    </MemoEditDialogStateProvider>
  );
};
